import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  open,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-164">
      {open && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} data-id="element-165">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-forest/60 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-166" />

          {/* Panel */}
          <motion.div role="dialog" aria-modal="true" aria-labelledby="legal-modal-title" className="relative bg-cream rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col border border-sage/20" initial={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} data-id="element-167">
            <div className="flex items-start justify-between gap-6 p-6 md:p-8 border-b border-sage/15" data-id="element-168">
              <h2 id="legal-modal-title" className="text-2xl md:text-3xl font-serif text-forest" data-id="element-169">
                {title}
              </h2>
              <button type="button" onClick={onClose} aria-label="Cerrar" className="shrink-0 p-2 rounded-full text-forest/60 hover:text-forest hover:bg-sage/10 transition-colors" data-id="element-170">
                <XIcon size={20} data-id="element-171" />
              </button>
            </div>

            <div className="overflow-y-auto p-6 md:p-8 text-charcoal/80 leading-relaxed text-sm md:text-base space-y-4" data-id="element-172">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}